import { apiClient } from '@/api/client';
import type { SpringPage } from '@/types/students';

/**
 * Minimal Team shape for the discipline page's team multi-select.
 */
export interface TeamOption {
  id: number;
  name: string | null;
}

/**
 * List teams of one community. Backed by the existing private endpoint
 * `GET /private/communities/{communityId}/teams`. Teams are returned in
 * the order the backend chooses (asc by createdAt by default).
 */
export async function listCommunityTeams(
  communityId: number,
): Promise<TeamOption[]> {
  const { data } = await apiClient.get<SpringPage<TeamOption>>(
    `/private/communities/${communityId}/teams`,
    { params: { page: 0, size: 100 } },
  );
  return data.content;
}
